import React from 'react';
import GalleryBanner from './GalleryBanner';
import GallerContainerPage from './GallerContainerPage';

const GalleryPage = () => (
	<div>
		<GalleryBanner />

		<GallerContainerPage />
	</div>
);

export default GalleryPage;
